import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
export function ValueStack() {
  return <section className="bg-cream-50 py-16" data-id="element-307">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-308">
        <div className="text-center mb-10" data-id="element-309">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-310">
            Mirá lo que te llevás hoy:
          </h2>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border-2 border-orange-100 overflow-hidden" data-id="element-311">
          <div className="p-6 md:p-8 space-y-6" data-id="element-312">
            {/* Main Product */}
            <div className="flex items-center justify-between pb-6 border-b border-gray-100" data-id="element-313">
              <div className="flex items-center gap-4" data-id="element-314">
                <div className="bg-green-100 p-2 rounded-full" data-id="element-315">
                  <CheckIcon className="w-6 h-6 text-green-600" data-id="element-316" />
                </div>
                <span className="text-lg font-semibold text-navy-900" data-id="element-317">
                  Mascota Sola: Guía Anti-Destrucción
                </span>
              </div>
              <span className="text-lg font-medium text-gray-600" data-id="element-318">
                $8.499 ARS
              </span>
            </div>

            {/* Bonus 1 */}
            <div className="flex items-center justify-between pb-6 border-b border-gray-100" data-id="element-319">
              <div className="flex items-center gap-4" data-id="element-320">
                <div className="bg-orange-100 p-2 rounded-full" data-id="element-321">
                  <GiftIcon className="w-6 h-6 text-orange-600" data-id="element-322" />
                </div>
                <span className="text-lg text-gray-800" data-id="element-323">
                  Bono 1: Kit Express de Salida Sin Drama
                </span>
              </div>
              <span className="text-lg text-gray-500 line-through" data-id="element-324">
                $19.000 ARS
              </span>
            </div>

            {/* Bonus 2 */}
            <div className="flex items-center justify-between pb-6 border-b border-gray-100" data-id="element-325">
              <div className="flex items-center gap-4" data-id="element-326">
                <div className="bg-orange-100 p-2 rounded-full" data-id="element-327">
                  <GiftIcon className="w-6 h-6 text-orange-600" data-id="element-328" />
                </div>
                <span className="text-lg text-gray-800" data-id="element-329">
                  Bono 2: Checklist Casa Calma en 15 Minutos
                </span>
              </div>
              <span className="text-lg text-gray-500 line-through" data-id="element-330">
                $22.000 ARS
              </span>
            </div>

            {/* Bonus 3 */}
            <div className="flex items-center justify-between pb-6 border-b border-gray-100" data-id="element-331">
              <div className="flex items-center gap-4" data-id="element-332">
                <div className="bg-orange-100 p-2 rounded-full" data-id="element-333">
                  <GiftIcon className="w-6 h-6 text-orange-600" data-id="element-334" />
                </div>
                <span className="text-lg text-gray-800" data-id="element-335">
                  Bono 3: Recetario de Enfoque y Masticación Tranquila
                </span>
              </div>
              <span className="text-lg text-gray-500 line-through" data-id="element-336">
                $22.000 ARS
              </span>
            </div>

            {/* Total Value */}
            <div className="flex items-center justify-between pt-4" data-id="element-337">
              <span className="text-xl font-medium text-gray-500" data-id="element-338">
                Valor total real
              </span>
              <span className="text-xl font-medium text-gray-400 line-through" data-id="element-339">
                $71.499 ARS
              </span>
            </div>

            {/* Final Price */}
            <div className="flex items-center justify-between bg-orange-50 p-6 rounded-xl border border-orange-200 mt-6" data-id="element-340">
              <span className="text-2xl font-bold text-navy-900" data-id="element-341">
                Tu inversión hoy
              </span>
              <span className="text-3xl md:text-4xl font-bold text-orange-600" data-id="element-342">
                $8.499 ARS
              </span>
            </div>
          </div>

          <div className="bg-navy-900 text-white p-6 text-center" data-id="element-343">
            <p className="text-lg font-medium" data-id="element-344">
              Todo lo que necesitás para que tu perro empiece a quedarse solo
              con menos ansiedad, menos destrozos y más calma.
            </p>
            <p className="text-orange-300 mt-2" data-id="element-345">
              No en semanas. No después de meses de adiestramiento caro. Desde
              el primer día que aplicás la rutina.
            </p>
          </div>
        </div>
      </div>
    </section>;
}